import { Project } from '@dc-shared-web/hooks/api/project/types'
import { useAxiosContext } from '@dc-shared-web/providers'
import { AxiosInstance } from 'axios'
import { useQuery } from 'react-query'

interface ProjectResponse {
  data: Project
  parentFolder: {
    id: number
    name: string
  }
}

const fetchProjectById = async (
  apiClient: AxiosInstance,
  projectId: number
): Promise<ProjectResponse> => {
  const { data } = await apiClient.get(`/ajax/project-info/${projectId}`)
  return data
}

export const useGetProjectById = (
  projectId: number,
  enabled: boolean = true
) => {
  const apiClient = useAxiosContext()

  return useQuery<ProjectResponse, Error>({
    queryKey: ['Project', projectId],
    queryFn: () => fetchProjectById(apiClient, projectId),
    enabled,
  })
}
